module.exports = __webpack_public_path__ + "static/media/LMHSB168.88c271f7.png";